module.exports = __webpack_public_path__ + "static/media/DocumentAwaitingPlan.3e55f290.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/DocumentAwaitingPlan.svg
// module id = 726
// module chunks = 0